webpackJsonp([1],{

/***/ 0:
/*!***************************!*\
  !*** ./src/app_public.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(/*! react */ 29);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPublic = __webpack_require__(/*! ./components/public */ 159);
	
	var unencodeField = function unencodeField(selector) {
	  return $.parseJSON($('<textarea />').html($(selector).html()).html());
	};
	
	var admin = Boolean($('#admin-data').html());
	var eb = Boolean($('#eb-data').html());
	var fees = unencodeField('#fee-data');
	var addons = unencodeField('#addon-data');
	var fields = unencodeField('#field-data');
	
	_react2['default'].render(_react2['default'].createElement(_componentsPublic.RegForm, { fields: fields, fees: fees, addons: addons, eb: eb, admin: admin }), document.getElementById('form-container'));

/***/ },

/***/ 159:
/*!**********************************!*\
  !*** ./src/components/public.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(/*! react */ 29);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _form = __webpack_require__(/*! ./form */ 82);
	
	var RegForm = (function (_React$Component) {
	  _inherits(RegForm, _React$Component);
	
	  function RegForm(props) {
	    var _this = this;
	
	    _classCallCheck(this, RegForm);
	
	    _get(Object.getPrototypeOf(RegForm.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      fee: undefined,
	      addons: [],
	      subtotal: 0,
	      tax: 0,
	      total: 0,
	      submitting: false,
	      payment_errors: undefined,
	      stripe_token: undefined,
	      admin_bypass_payment: false,
	      payment_method: undefined,
	      payment_required: true
	    };
	
	    ['handleStateChange'].forEach(function (i) {
	      _this[i] = _this[i].bind(_this);
	    });
	  }
	
	  _createClass(RegForm, [{
	    key: 'handleStateChange',
	    value: function handleStateChange(change_type, change) {
	      var state = this.state;
	      switch (change_type) {
	        case 'CHANGE_FEE':
	          state.fee = change;
	          break;
	        case 'ADD_ADDON':
	          state.addons.push(change);
	          break;
	        case 'REMOVE_ADDON':
	          var i = state.addons.findIndex(function (a) {
	            return a.id == change.id;
	          });
	          state.addons.splice(i, 1);
	          break;
	        case 'CHANGE_PAYMENT_METHOD':
	          state.payment_method = change;
	          break;
	      }
	
	      // payment required?
	      state.payment_required = state.admin_bypass_payment || state.payment_method == 'Cheque' ? false : true;
	
	      // recalculate fees
	      state.subtotal = state.tax = state.total = 0;
	      var fee_index = this.props.eb ? 'eb_' : '';
	      if (state.fee) {
	        state.subtotal += Number(state.fee[fee_index + 'subtotal']);
	        state.tax += Number(state.fee[fee_index + 'tax']);
	        state.total += Number(state.fee[fee_index + 'total']);
	      }
	
	      state.addons.forEach(function (a) {
	        state.subtotal += Number(a[fee_index + 'subtotal']);
	        state.tax += Number(a[fee_index + 'tax']);
	        state.total += Number(a[fee_index + 'total']);
	      });
	
	      this.setState(state);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var that = this;
	
	      $('input[name=admin_bypass_payment]').change(function () {
	        that.setState({ admin_bypass_payment: $(this).prop('checked') });
	      });
	
	      // making life simple by keeping validation out of React for now
	      $('#event-form').validate({
	        errorElement: 'span',
	        errorClass: 'red',
	        errorPlacement: function errorPlacement(error, element) {
	          error.appendTo(element.closest('.control-group').find('.error-target'));
	        },
	        submitHandler: function submitHandler(form) {
	          var $form = $(form);
	          var skip_payment = that.state.total <= 0 || that.state.payment_method == 'Cheque' || that.props.admin && $('input[name=admin_bypass_payment]:checked').length;
	
	          var pay_data = {
	            name: $('#card-name').val(),
	            number: $('#card-number').val(),
	            exp_month: $('#card-exp-month').val(),
	            exp_year: $('#card-exp-year').val()
	          };
	          if ($('#card-cvc').val() && $('#card-cvc').val() != '') {
	            pay_data['cvc'] = $('#card-cvc').val();
	          }
	
	          if (that.state.submitting) {
	            return false;
	          }
	
	          $form.find('.btn-submit').hide();
	          $form.find('.loading-spinner').show();
	          that.setState({ submitting: true });
	
	          if (skip_payment) {
	            return true;
	          } else {
	            Stripe.card.createToken(pay_data, function (status, response) {
	              if (response.error) {
	                that.setState({ submitting: false, payment_errors: response.error.message });
	                $form.find('.btn-submit').show();
	                $form.find('.loading-spinner').hide();
	              } else {
	                // set stripe token and submit
	                that.setState({ stripe_token: response['id'] });
	                $form[0].submit();
	              }
	            });
	            return false;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var addons = undefined;
	      if (this.props.addons && this.props.addons.length > 0) {
	        addons = _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h2',
	            null,
	            'Add-ons:'
	          ),
	          _react2['default'].createElement(_form.AddonOptionList, { addons: this.props.addons, handleChange: this.handleStateChange, eb: this.props.eb })
	        );
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: 'reg-form' },
	        _react2['default'].createElement(
	          'h2',
	          null,
	          'Please select a fee:'
	        ),
	        _react2['default'].createElement(_form.FeeOptionList, { fees: this.props.fees, handleChange: this.handleStateChange, eb: this.props.eb }),
	        addons,
	        _react2['default'].createElement(
	          'h2',
	          null,
	          'Registration information:'
	        ),
	        _react2['default'].createElement(_form.FieldList, { fields: this.props.fields }),
	        _react2['default'].createElement(
	          'h2',
	          null,
	          'Payment information:'
	        ),
	        _react2['default'].createElement(_form.PaymentInfo, { subtotal: this.state.subtotal, tax: this.state.tax, total: this.state.total, stripe_token: this.state.stripe_token, payment_errors: this.state.payment_errors, payment_method: this.state.payment_method, payment_required: this.state.payment_required, handleChange: this.handleStateChange })
	      );
	    }
	  }]);
	
	  return RegForm;
	})(_react2['default'].Component);
	
	exports.RegForm = RegForm;

/***/ }

});


/** WEBPACK FOOTER **
 ** app_public.js
 **/